// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    width: 350px;
    margin: 50px auto;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    background-color: #f9f9f9;
    text-align: center;
}

.login-container h3 {
    margin-bottom: 20px;
    font-size: 1.5em;
    color: #333;
}

.login-container input {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
    font-size: 1em;
}

.login-container button {
    width: 100%;
    padding: 10px;
    margin-top: 15px;
    background-color: #007BFF;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1em;
}

.login-container button:hover {
    background-color: #0056b3;
}

.login-container button:last-child {
    background-color: #6c757d;
}

.login-container button:last-child:hover {
    background-color: #5a6268;
}

.user-icon:hover {
    opacity: 0.8;
}

.dropdown {
    position: absolute;
    right: 0;
    background-color: white;
    color: black;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    width: 200px;
    text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/css/LoginPage.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,2CAA2C;IAC3C,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,YAAY;IACZ,gBAAgB;AACpB","sourcesContent":[".login-container {\n    width: 350px;\n    margin: 50px auto;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    background-color: #f9f9f9;\n    text-align: center;\n}\n\n.login-container h3 {\n    margin-bottom: 20px;\n    font-size: 1.5em;\n    color: #333;\n}\n\n.login-container input {\n    width: 100%;\n    padding: 10px;\n    margin: 10px 0;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 1em;\n}\n\n.login-container button {\n    width: 100%;\n    padding: 10px;\n    margin-top: 15px;\n    background-color: #007BFF;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 1em;\n}\n\n.login-container button:hover {\n    background-color: #0056b3;\n}\n\n.login-container button:last-child {\n    background-color: #6c757d;\n}\n\n.login-container button:last-child:hover {\n    background-color: #5a6268;\n}\n\n.user-icon:hover {\n    opacity: 0.8;\n}\n\n.dropdown {\n    position: absolute;\n    right: 0;\n    background-color: white;\n    color: black;\n    padding: 10px;\n    border-radius: 5px;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    width: 200px;\n    text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
